import { Controller } from "@hotwired/stimulus"

// Drives the public member application form's repeatable Reference and
// Social link rows. Each <template> holds a `fields_for` block rendered
// with index: "NEW_RECORD" (same trick as the chapter_admin event form's
// exclusions) so a clone just needs its index swapped for a unique stamp.
export default class extends Controller {
  static targets = [
    "referencesList", "referenceTemplate",
    "socialLinksList", "socialLinkTemplate"
  ]

  addReference() {
    this.appendRow(this.referenceTemplateTarget, this.referencesListTarget)
  }

  addSocialLink() {
    this.appendRow(this.socialLinkTemplateTarget, this.socialLinksListTarget)
  }

  appendRow(template, list) {
    const stamp = Date.now()
    const fragment = template.content.cloneNode(true)
    fragment.querySelectorAll("[name], [id], [for]").forEach(el => {
      ;["name", "id", "for"].forEach(attr => {
        if (el.hasAttribute(attr)) {
          el.setAttribute(attr, el.getAttribute(attr).replace("NEW_RECORD", stamp))
        }
      })
    })
    list.insertBefore(fragment, list.querySelector(".buttons"))
  }

  removeRow(e) {
    e.target.closest(".repeater-row").remove()
  }
}
